export const publicRoutes = {
  landing: '/',
  login: '/login',
  selectScope: '/select-scope',
  track: '/track',
  portalLogin: '/portal/login',
  portal: '/portal',
} as const;

export const scopedRoutes = {
  dashboard: 'dashboard',
  shipments: 'shipments',
  scan: 'scan',
  consolidations: 'consolidations',
  deliveries: 'deliveries',
  customers: 'customers',
  warehouses: 'warehouses',
  drivers: 'drivers',
  tariffs: 'tariffs',
} as const;

export type ScopedRouteKey = keyof typeof scopedRoutes;

export interface RouteScope {
  tenantId: string;
  companyId: string;
}

export function buildScopedPath(
  routeKey: ScopedRouteKey,
  scope: RouteScope,
  query?: Record<string, string | number | null | undefined>,
): string {
  const base = `/${scope.tenantId}/${scope.companyId}/${scopedRoutes[routeKey]}`;
  if (!query) return base;
  const entries = Object.entries(query).filter(([, v]) => v !== null && v !== undefined && v !== '');
  if (!entries.length) return base;
  return `${base}?${new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString()}`;
}

const GUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export function isLikelyGuid(v: string | null | undefined): v is string {
  return !!v && GUID_RE.test(v);
}

export function parseScopeFromPath(pathname: string): RouteScope | null {
  const m = pathname.match(/^\/([^/]+)\/([^/]+)(?:\/|$)/);
  if (!m) return null;
  const [, tenantId, companyId] = m;
  if (!isLikelyGuid(tenantId) || !isLikelyGuid(companyId)) return null;
  return { tenantId, companyId };
}
